/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.Organization = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Organization model module.
   * @module model/Organization
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>Organization</code>.
   * @alias module:model/Organization
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>Organization</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Organization} obj Optional instance to populate.
   * @return {module:model/Organization} The populated <code>Organization</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BusinessId')) {
        obj['BusinessId'] = ApiClient.convertToType(data['BusinessId'], 'String');
      }
      if (data.hasOwnProperty('MainName')) {
        obj['MainName'] = ApiClient.convertToType(data['MainName'], 'String');
      }
      if (data.hasOwnProperty('RegistrationDate')) {
        obj['RegistrationDate'] = ApiClient.convertToType(data['RegistrationDate'], 'Date');
      }
      if (data.hasOwnProperty('CompanyFormId')) {
        obj['CompanyFormId'] = ApiClient.convertToType(data['CompanyFormId'], 'Integer');
      }
      if (data.hasOwnProperty('WebsiteURI')) {
        obj['WebsiteURI'] = ApiClient.convertToType(data['WebsiteURI'], 'String');
      }
      if (data.hasOwnProperty('WebsiteSnapshotURI')) {
        obj['WebsiteSnapshotURI'] = ApiClient.convertToType(data['WebsiteSnapshotURI'], 'String');
      }
      if (data.hasOwnProperty('WebsiteSnapshotLastModified')) {
        obj['WebsiteSnapshotLastModified'] = ApiClient.convertToType(data['WebsiteSnapshotLastModified'], 'Date');
      }
      if (data.hasOwnProperty('WebsiteSnapshotLastErrorText')) {
        obj['WebsiteSnapshotLastErrorText'] = ApiClient.convertToType(data['WebsiteSnapshotLastErrorText'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} BusinessId
   * @default ''
   */
  exports.prototype['BusinessId'] = '';
  /**
   * @member {String} MainName
   * @default ''
   */
  exports.prototype['MainName'] = '';
  /**
   * @member {Date} RegistrationDate
   */
  exports.prototype['RegistrationDate'] = undefined;
  /**
   * @member {Integer} CompanyFormId
   */
  exports.prototype['CompanyFormId'] = undefined;
  /**
   * @member {String} WebsiteURI
   * @default ''
   */
  exports.prototype['WebsiteURI'] = '';
  /**
   * @member {String} WebsiteSnapshotURI
   * @default ''
   */
  exports.prototype['WebsiteSnapshotURI'] = '';
  /**
   * @member {Date} WebsiteSnapshotLastModified
   */
  exports.prototype['WebsiteSnapshotLastModified'] = undefined;
  /**
   * @member {String} WebsiteSnapshotLastErrorText
   * @default ''
   */
  exports.prototype['WebsiteSnapshotLastErrorText'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


